import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { Link } from "react-router-dom";

import Needs from "./Needs";
import NeedButton from "./NeedButton";


@inject('core')
@observer
export default class ProductList extends React.Component {
	
	componentDidMount() {
		const { core } = this.props
		
		
	}

	render() {
		const { core, filter, mark_uncheap_store_id, showNeeds, showNeedButton } = this.props
		
		const f = (typeof filter === 'undefined') ? () => true : filter;
		
		const _productList = core.products.slice()
			.filter(f)
			.filter(p => {
				if (!core.productFilter) return true
				if (core.productFilter == '*') return true
				return p.name.toLowerCase().indexOf(core.productFilter.toLowerCase()) >= 0
			})
			.sort((a, b) => a.name.localeCompare(b.name))
			
		const productList = _productList.map((product) => {
				
				const classes = ['product-line']
				
				if (mark_uncheap_store_id) {
				
					var cheapest  = false
					var min_price = 9999
					
					Object.keys(product.prices).map(key => {
						const price = product.prices[key]
						if (price) min_price = Math.min(min_price, price)
					})
					
					if (product.prices[mark_uncheap_store_id] > min_price) {
						classes.push('uncheap')
					}

				}
				
				var need       = showNeeds ? <Needs product_id={product.product_id} /> : null;
				var needButton = showNeedButton ? <NeedButton product_id={product.product_id} /> : null;
				
				return <div key={product.product_id} className={classes.join(' ')}>
					{need}
					<Link className="product-link" to={"/" + core.pod_id + "/product/" + product.product_id}>{product.name}</Link>
					{needButton}
				</div>
			})
		
		return <div>
		{productList}
		</div>
	}
	
}


